import { Capacitor } from '@capacitor/core';
import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';

const isNative = Capacitor.isNativePlatform();

/** Light tick — like/pass commit, small toggles, chip selection. */
export function hapticLight(): void {
  if (!isNative) return;
  Haptics.impact({ style: ImpactStyle.Light }).catch(() => {});
}

/** Medium thud — primary CTAs, sheet-level confirmations. */
export function hapticMedium(): void {
  if (!isNative) return;
  Haptics.impact({ style: ImpactStyle.Medium }).catch(() => {});
}

/** Success buzz — match created, couple formed. */
export function hapticSuccess(): void {
  if (!isNative) return;
  Haptics.notification({ type: NotificationType.Success }).catch(() => {});
}

/** Selection tick — onboarding option taps, pickers. */
export function hapticSelect(): void {
  if (!isNative) return;
  Haptics.selectionStart()
    .then(() => Haptics.selectionChanged())
    .then(() => Haptics.selectionEnd())
    .catch(() => {});
}
